export default {
  path: '/nozzle_visuals',
  name: 'nozzle_visuals',
  component: () => import('../components/nozzlevisual/Layout'),
  redirect: { name: 'NozzleVisualList' },
  meta: {
    breadcrumb: 'profile.nozzle.visuals',
  },
  children: [
    {
      name: 'NozzleVisualList',
      path: '',
      component: () => import('../views/nozzlevisual/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleVisualCreate',
      path: 'new',
      component: () => import('../views/nozzlevisual/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleVisualUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzlevisual/Update'),
      meta: {
        breadcrumb: 'profile.nozzle.visual',
      },
    },
    {
      name: 'NozzleVisualShow',
      path: ':id',
      component: () => import('../views/nozzlevisual/Show'),
      meta: {
        breadcrumb: 'profile.nozzle.visual',
      },
    }
  ]
};
